import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Validacion from "../pages/admin/Validacion";
import Agente from "../pages/agent/Agente";
import EstadoValidacion from "../components/admin/EstadoValidacion";
import CargaBase from "../pages/admin/CargaBase";
import TablaLineaNegocio from "../pages/admin/mantenimiento/lineaNegocio";
import UsersManager from "../pages/admin/mantenimiento/usuario";
import AdminGestionVenta from "../pages/admin/contactos";
import Reports from "../pages/admin/reports";
import Dashboard from "../pages/admin/dashboard";
import ClientList from "../pages/admin/contactos/ClientList";
import UserProfile from "../pages/admin/settings/UserProfile";
import ClientAdd from "../pages/admin/contactos/ClientAdd";
import AlfinVenta from "../pages/admin/contactos/alfin/AlfinVenta";
import CargaEstadoCuenta from "../pages/admin/contactos/alfin/getEstadoCuenta";
import Tipificacion from "../components/admin/tipificacion";


const ProtectedRoutes = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    const isSuperuser = user ? user.is_superuser : false;
    const hasPermission = (permission) => permissions.includes(permission);

    let rootComponent = <AdminGestionVenta />;
    if (!isSuperuser) {
        if (hasPermission('auth.agente') && hasPermission('auth.fichaalfin')) {
            rootComponent = <AdminGestionVenta />;
        } else if (hasPermission('auth.agente')) {
            rootComponent = <AdminGestionVenta />;
        } else if (hasPermission('auth.fichaalfin')) {
            rootComponent = <AlfinVenta />;
        }
    }
    return (
        <PrivateRoute>
            <Routes>
                {!isSuperuser && (
                    <>
                        <Route path="/" element={rootComponent} />
                        <Route path="/dashboard" element={<Dashboard />} />

                        <Route path="/contacts/search" element={<AdminGestionVenta />} />
                    </>
                )  
                }
                {isSuperuser && (
                    <>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/agente" element={<Agente />} />
                        <Route path="/campaign/config" element={<TablaLineaNegocio />} />
                        <Route path="/validacion/validacion" element={<Validacion />} />
                        <Route path="/validacion/estados" element={<EstadoValidacion />} />
                        <Route path="/campaign/base" element={<CargaBase />} />
                        <Route path="/alfin/consultaEstados" element={<CargaEstadoCuenta />} />
                        <Route path="/campaign/servicios" element={<TablaLineaNegocio />} />
                        <Route path="/reportes" element={<Reports />} />
                        <Route path="/users" element={<UsersManager />} />
                        <Route path="/contacts/list" element={<ClientList />} />
                        <Route path="/settings/perfil" element={<UserProfile />} />
                        <Route path="/contacts/search" element={<AdminGestionVenta />} />
                        <Route path="/contacts/add" element={<ClientAdd />} />
                        <Route path="/contacts/ventaAlfin" element={<AlfinVenta />} />
                        <Route path="/tipificacion" element={<Tipificacion />} />
                        
                        
                    </>
                )}
            </Routes>
        </PrivateRoute>
    );
}

export default ProtectedRoutes;
